module.exports = __webpack_public_path__ + "static/media/gusset-box-interior.d7edc3dc.png";